import { useRequestURL } from "nuxt/app";
export default defineNuxtPlugin(nuxtApp => {
  const dataAll = useDataAll()
  const runtimeConfig = useRuntimeConfig();
  const { $apiMethods, $helpers } = useNuxtApp()
  const methods = {

    // formatLink(linkToFormat) {

    //   //       format links, lower case, spaces to - and localisation
    //   if (typeof linkToFormat === 'string' || linkToFormat instanceof String) {
    //     return $methods.localePath((linkToFormat.replaceAll(" ", "-")).toLowerCase());
    //   } else {
    //     return '';
    //   }
    // },

    checkObjectFieldsExists(dataObject,checkFields, logname) {

      let errorString = ""; // String to store error messages
      for (const field of checkFields) {
         if (!$helpers.isset(dataObject[field])) {
          // Add an error message if the field is not set
          errorString += `${field} is not set.\n`;
         }
      }
    
      // If there are errors, log them and return false; otherwise, return true
      if (errorString != "") {
        methods.logError("Missing fields in json:" +logname+" "+ errorString);
        return false;
      }
      return true; // If everything is in order, return true
    },


    changeThemeFields(arrIn) {
      let themeIn = [];
      if (typeof (arrIn) != "undefined" && arrIn !== null && 
          arrIn.Theme01Primary && 
          arrIn.Theme02Secondary && 
          arrIn.Theme03Accent && 
          arrIn.Theme04Error && 
          arrIn.Theme05Info && 
          arrIn.Theme06Success && 
          arrIn.Theme07Warning && 
          arrIn.Theme08Text&& 
          arrIn.Theme09LightText&& 
          arrIn.Theme10Contrast&& 
          arrIn.Theme11Backgrond1&& 
          arrIn.Theme12Backgrond2) {

        // update theme values
        themeIn.primary = arrIn.Theme01Primary;
        themeIn.secondary = arrIn.Theme02Secondary;
        themeIn.accent = arrIn.Theme03Accent;
        themeIn.error = arrIn.Theme04Error;
        themeIn.info = arrIn.Theme05Info;
        themeIn.success = arrIn.Theme06Success;
        themeIn.warning = arrIn.Theme07Warning;
        themeIn.text = arrIn.Theme08Text;
        themeIn.lighttext = arrIn.Theme09LightText;
        themeIn.contrast = arrIn.Theme10Contrast;
        themeIn.background1 = arrIn.Theme11Backgrond1;
        themeIn.background2 = arrIn.Theme12Backgrond2;
        // Save theme values in vuetify object
        useNuxtApp().$vuetify.theme.themes._value.light.colors = themeIn
      }
    },
    // i18Key(key,defaultValue) {
    //   return $te(key)?$t(key):defaultValue
    // },
    async logError(errorString){
      
      const runtimeConfig = useRuntimeConfig();
      if (runtimeConfig.public.ALLOW_CLIENT_TO_LOG_ERRORS ==1 ){
        const formVars = { logString: errorString, level: "error" }
        await $apiMethods.postApiCall(
            $apiMethods.getApiHostUrl() + 
            "/api/" +
            $helpers.getLabelId()  +
            "/logClient", 
          $apiMethods.addSecurityparams(formVars))
      } else{
        console.log(errorString)
        console.log('Not logged to server')
      }  
    },
    // return url of first occurence of pagetype, only usefull is there is only one occurence
    urlPageType(pageType){
      const pageNames = dataAll.getKey('pageNames', [])
      let page = methods.pageByItemType(pageType)
      if (page && page.Code){
        return methods.localePath(pageNames[page.Code])
      }
      return methods.localePath("/")
    },
    // returns pageurl by pagetype in none found return to home
    pageUrlByPageType(pagetype){
      const pageTypeObj = this.pageByItemType(pagetype)
      if (pageTypeObj && pageTypeObj.Code){
        return this.pageLinkByCode(pageTypeObj.Code )
      }
      return this.localePath('/');
    },

    //returns the first occurense of page type in the WebPages array
    pageByItemType(pageType) {
      return usePageOverviewStore().getPageByType(pageType) || {}
    },
    // pageByItemType(pageType) { // PS
    //   let webPages = usePageOverviewStore().PageOverview
    //   //let webPages = null;
    //   let retValue = null
    //   if (webPages) {
    //     retValue =methods.pageByItemTypeSub(webPages, pageType)
    //   }
    //   return retValue?retValue:[];
    // },
    // pageByItemTypeSub(webPagesIn, pageType){ // pageOverview arr, PS
    //   for (let key in webPagesIn) {
    //     if ($helpers.isset(webPagesIn[key]) && $helpers.isset(webPagesIn[key]['PageType']) && webPagesIn[key]['PageType'] == pageType) {
    //       return webPagesIn[key]
    //     }
    //     if ($helpers.isset(webPagesIn[key]['SubPage']) && webPagesIn[key]['SubPage'].length>0){
    //       let retValue = methods.pageByItemTypeSub(webPagesIn[key]['SubPage'], pageType);
    //       if (retValue){
    //         return retValue
    //       }
    //     }
    //   }
    //   return null
    // },
    pageByCodeField(webPagesIn, code, searchField){
      for (let key in webPagesIn) {
        if ($helpers.isset(webPagesIn[key]) && $helpers.isset(webPagesIn[key][searchField]) && webPagesIn[key][searchField] == code) {
          return webPagesIn[key]
        }
        if ($helpers.isset(webPagesIn[key]['SubPage']) && webPagesIn[key]['SubPage'].length>0){
          let retValue = methods.pageByCodeField(webPagesIn[key]['SubPage'], code, searchField);
          if (retValue){
            return retValue
          }
        }
      }
      return null
    },
    pageLinkByCode(code) {
      let pageNames = usePageOverviewStore().getPageUrlByPageCode(code)
      if (pageNames && pageNames != '') {
        return methods.localePath(pageNames);
        //return searchInPagesWebCode(webPages,Code,'');

      }
      return methods.localePath("/"); // niets gevonden
    },



    getLanguageObjects() {
      const route = useRoute();
      return getLanguageObjectsURL( route.fullPath, $helpers.getLabelId());
    },
    localePath(varin) {
      if (dataAll.getDefaultLanguage() == dataAll.getLanguage()) {
        return varin;
      } else {
        return "/" + dataAll.getLanguage() + varin;
      }
    },


  }
  nuxtApp.provide('methods', methods);
})
